import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RejectOrderPage } from './reject-order.page';

const routes: Routes = [
  {
    path: '',
    component: RejectOrderPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RejectOrderPageRoutingModule {}
